import React from 'react';

class FunctionHelpers {
    sortData(array, filter, asc = false) {
        let sortedData = array.sort(function (a, b) {
            var x = a[filter];
            var y = b[filter];
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        });
        if (asc)
            return sortedData;
        else
            return sortedData.reverse();
    }

    formatDate(date = new Date(), format = "d/m/Y") {
        let dia = date.getDate().toString(),
            diaF = (dia.length == 1) ? '0' + dia : dia,
            mes = (date.getMonth() + 1).toString(),
            mesF = (mes.length == 1) ? '0' + mes : mes,
            anoF = date.getFullYear();
        switch (format) {
            case "d-m-Y":
                return diaF + "-" + mesF + "-" + anoF;
            default:
                return diaF + "/" + mesF + "/" + anoF;
        }
    }
}
export default FunctionHelpers;